// Owner 2026-10-16 (requirement 60): customer rating on the digital nota.
// Pure helpers (no "@/" imports) so Jest can test them.
export const BINTANG_TEKS = { 1: "Sangat kurang", 2: "Kurang", 3: "Cukup", 4: "Baik", 5: "Sangat baik" };
export const MAKS_CATATAN = 500;

// The send button is enabled only with a star chosen and a note within the limit.
export function siapKirim({ bintang, catatan }) {
  return Number.isInteger(bintang) && bintang >= 1 && bintang <= 5 && (catatan || "").length <= MAKS_CATATAN;
}

// "4,3 ★" for an average, "—" when there is none.
export function rataTeks(x) {
  return x == null ? "—" : `${x.toLocaleString("id-ID", { minimumFractionDigits: 1, maximumFractionDigits: 1 })} ★`;
}

// The quick marks the customer ticked, toggled one at a time (order kept as on screen).
export function gantiTanda(daftar, kunci) {
  return daftar.includes(kunci) ? daftar.filter((x) => x !== kunci) : [...daftar, kunci];
}
